import React from 'react';
import { Svelte } from '../utils/SvelteToReact';
import { Tooltip as TooltipSvelte } from '@glance-networks/ui-core-components';

export const Tooltip = (props) => {
  const defineProps = {};
  
  if (props.visible !== undefined) defineProps.visible = props.visible;
  if (props.text !== undefined) defineProps.text = props.text;
  if (props.position !== undefined) defineProps.position = props.position;
  if (props.strategy !== undefined) defineProps.strategy = props.strategy;
  // Let DS defaults apply unless explicitly set.
  // `shift` is used as viewport padding in the DS tooltip overlay.
  if (props.shift !== undefined) defineProps.shift = props.shift;
  if (props.flip !== undefined) defineProps.flip = props.flip;
  if (props.size !== undefined) defineProps.size = props.size;
  if (props.mouseenterTimeout !== undefined) defineProps.mouseenterTimeout = props.mouseenterTimeout;
  defineProps.inline = props.inline || false;
  if (props.offset !== undefined) defineProps.offset = props.offset;

  return (
    <Svelte component={TooltipSvelte} {...defineProps}>
      {props.children}
    </Svelte>
  );
};
